import { CommandBuffer } from "../../../d3/core/render/command/CommandBuffer";
import { Vector4 } from "../../../maths/Vector4";
import { WebGLDirectLightShadowRP } from "./WebGLDirectLightShadowRP";
import { WebGLForwardAddClusterRP } from "./WebGLForwardAddClusterRP";
import { WebGLSpotLightShadowRP } from "./WebGLSpotLightShadowRP";
export class WebGLForwardAddRP {
    constructor() {
        this.shadowCastPass = false;
        this.enableDirectLightShadow = false;
        this.enableSpotLightShadowPass = false;
        this.enablePostProcess = true;
        this.directLightShadowPass = new WebGLDirectLightShadowRP();
        this.spotLightShadowPass = new WebGLSpotLightShadowRP();
        this.shadowParams = new Vector4();
        this.renderpass = new WebGLForwardAddClusterRP();
        this.finalize = new CommandBuffer();
    }
    setBeforeImageEffect(value) {
        if (value && value.length > 0) {
            this._beforeImageEffectCMDS = value;
            value.forEach(element => {
                element._apply(false);
            });
        }
    }
    setAfterEventCmd(value) {
        if (value && value.length > 0) {
            this._afterAllRenderCMDS = value;
            value.forEach(element => {
                element._apply(false);
            });
        }
    }
    destroy() {
        this._afterAllRenderCMDS = null;
        this._beforeImageEffectCMDS = null;
        this.renderpass.destroy();
        this.directLightShadowPass.destroy();
        this.spotLightShadowPass.destroy();
        this.finalize.clear();
        this.finalize = null;
    }
}
